// Background loading status of Power BI reports, shown in the header.
// Not persisted: it describes iframes that only exist in the current page.
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  // Reports in sidebar order that can be embedded: [{ id, name }]
  plan: [],
  // How many reports are kept loaded at most (visible + background).
  maxKept: 0,
  // reportId -> 'loading' | 'ready' | 'slow' | 'error'
  statusById: {},
};

const reportPreloadSlice = createSlice({
  name: 'reportPreload',
  initialState,
  reducers: {
    setPreloadPlan: (state, action) => {
      state.plan = action.payload.plan;
      state.maxKept = action.payload.maxKept;
    },
    setReportLoadStatus: (state, action) => {
      const { id, status } = action.payload;
      if (!id) return;
      if (status) state.statusById[id] = status;
      else delete state.statusById[id];
    },
    resetReportPreload: () => initialState,
  },
});

export const { setPreloadPlan, setReportLoadStatus, resetReportPreload } =
  reportPreloadSlice.actions;
export default reportPreloadSlice.reducer;
